import { render, staticRenderFns } from "./risk-first-trial-view.vue?vue&type=template&id=13b19063&scoped=true&"
import script from "./risk-first-trial-view.vue?vue&type=script&lang=js&"
export * from "./risk-first-trial-view.vue?vue&type=script&lang=js&"
import style0 from "./risk-first-trial-view.vue?vue&type=style&index=0&id=13b19063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b19063",
  null
  
)

export default component.exports